export default "__VITE_PUBLIC_ASSET__66746ed1__"